import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Canonical KPI / stat card for both apps — the integrator's list-page summary card
 * (colored icon box + big value + uppercase label), previously copy-pasted inline in
 * dashboard / devices-list / gateways-list etc. `iconBg`/`dotColor` take any CSS colour so the
 * per-metric accent (online green, offline red…) is preserved exactly.
 *
 *   <wh-kpi-card [value]="online()" label="Online" iconBg="#DEF7EC" dotColor="#31C48D" />
 */
@Component({
  selector: 'wh-kpi-card',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
  template: `
    <div
      class="flex items-center gap-3 rounded-xl border border-gray-200 bg-white px-3 py-3 sm:gap-3.5 sm:px-4 sm:py-3.5 dark:border-slate-700 dark:bg-slate-800">
      <div
        class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg sm:h-10 sm:w-10"
        [style.background]="iconBg()">
        <span class="block h-3 w-3 rounded-full" [style.background]="dotColor()"></span>
      </div>
      <div class="min-w-0">
        <div class="text-xl font-bold leading-none text-gray-900 sm:text-2xl dark:text-slate-100">
          {{ value() }}
        </div>
        <div class="mt-1 text-xs font-semibold uppercase tracking-wider text-gray-500 sm:text-xs dark:text-slate-400">
          {{ label() }}
        </div>
      </div>
    </div>
  `,
})
export class WhKpiCardComponent {
  readonly value = input<string | number>('');
  readonly label = input<string>('');
  /** Icon box background (any CSS colour). */
  readonly iconBg = input<string>('#f3f4f6');
  /** Inner dot colour (any CSS colour). */
  readonly dotColor = input<string>('#9ca3af');
}
